import { EInfrastructureItem } from '../../api-models/common/json_query';
import { TJsonQueryKeys } from '../types';

type InfrastructureField = Extract<
  TJsonQueryKeys,
  | 'infrastructure_has_car_wash'
  | 'infrastructure_has_car_service'
  | 'infrastructure_has_pharmacy'
  | 'infrastructure_has_clothes_studio'
  | 'infrastructure_has_atm'
  | 'infrastructure_has_pool'
  | 'infrastructure_has_buffet'
  | 'infrastructure_has_exhibition_and_warehouse_complex'
  | 'infrastructure_has_hotel'
  | 'infrastructure_has_cafe'
  | 'infrastructure_has_cinema'
  | 'infrastructure_has_conference_room'
  | 'infrastructure_has_medical_center'
  | 'infrastructure_has_minimarket'
  | 'infrastructure_has_notary_office'
  | 'infrastructure_has_bank_department'
  | 'infrastructure_has_park'
  | 'infrastructure_has_restaurant'
  | 'infrastructure_has_beauty_shop'
  | 'infrastructure_has_warehouse'
  | 'infrastructure_has_canteen'
  | 'infrastructure_has_supermarket'
  | 'infrastructure_has_shopping_area'
  | 'infrastructure_has_fitness_centre'
  | 'infrastructure_has_studio'
  | 'infrastructure_has_central_reception'
>;

export const infrastructureItemToJsonQueryFieldMap: Record<EInfrastructureItem, InfrastructureField> = {
  [EInfrastructureItem.CarWash]: 'infrastructure_has_car_wash',
  [EInfrastructureItem.CarService]: 'infrastructure_has_car_service',
  [EInfrastructureItem.Pharmacy]: 'infrastructure_has_pharmacy',
  [EInfrastructureItem.ClothesStudio]: 'infrastructure_has_clothes_studio',
  [EInfrastructureItem.ATM]: 'infrastructure_has_atm',
  [EInfrastructureItem.Pool]: 'infrastructure_has_pool',
  [EInfrastructureItem.Buffet]: 'infrastructure_has_buffet',
  [EInfrastructureItem.WarehouseComplex]: 'infrastructure_has_exhibition_and_warehouse_complex',
  [EInfrastructureItem.Hotel]: 'infrastructure_has_hotel',
  [EInfrastructureItem.Cafe]: 'infrastructure_has_cafe',
  [EInfrastructureItem.Cinema]: 'infrastructure_has_cinema',
  [EInfrastructureItem.ConferenceRoom]: 'infrastructure_has_conference_room',
  [EInfrastructureItem.MedicalCenter]: 'infrastructure_has_medical_center',
  [EInfrastructureItem.Minimarket]: 'infrastructure_has_minimarket',
  [EInfrastructureItem.NotaryOffice]: 'infrastructure_has_notary_office',
  [EInfrastructureItem.Department]: 'infrastructure_has_bank_department',
  [EInfrastructureItem.Park]: 'infrastructure_has_park',
  [EInfrastructureItem.Restaurant]: 'infrastructure_has_restaurant',
  [EInfrastructureItem.BeautyShop]: 'infrastructure_has_beauty_shop',
  [EInfrastructureItem.Warehouse]: 'infrastructure_has_warehouse',
  [EInfrastructureItem.Canteen]: 'infrastructure_has_canteen',
  [EInfrastructureItem.Supermarket]: 'infrastructure_has_supermarket',
  [EInfrastructureItem.ShoppingArea]: 'infrastructure_has_shopping_area',
  [EInfrastructureItem.FitnessCentre]: 'infrastructure_has_fitness_centre',
  [EInfrastructureItem.Studio]: 'infrastructure_has_studio',
  [EInfrastructureItem.CentralReception]: 'infrastructure_has_central_reception',
};
